import axios from 'axios'
import { AccountDetail, AccountsTableApiResponse } from '../types/accountTable.types'
import { AccountByIdAddress, AccountByIdApiResponse, AccountByIdContact, AccountByIdItem } from '../types/accountById.types'
import { dropDown } from './interfaces'

const apiURL = process.env.REACT_APP_API_URL

export const getAccounts = async (): Promise<AccountsTableApiResponse> => {
    const token = localStorage.getItem('authToken')

    if (!token) {
        throw new Error('Authorization token not found')
    }

    const response: AccountsTableApiResponse = await axios.get(
        `https://${apiURL}/Account`,
        {
            headers: {
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + token,
            },
        }
    )

    return response
}

export const getAccountById = async (id: number): Promise<AccountByIdApiResponse> => {
    const token = localStorage.getItem('authToken')

    if (!token) {
        throw new Error('Authorization token not found')
    }

    const response: AccountByIdApiResponse = await axios.get(
        `https://${apiURL}/Account/${id}`,
        {
            headers: {
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + token,
            },
        }
    )
    return response
}

export const updateAccount = async (props: GetClientByIdV2): Promise<any> => {
    const token = localStorage.getItem('authToken');

    if (!token) {
        throw new Error('Authorization token not found');
    }

    const response = await axios.put(`https://${apiURL}/client/${props.clientId}`, props, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token,
        }
    });

    const data: any = response.data;
    return data;
}


export const createAccount = async (props: GetClientByIdV2): Promise<any> => {
    const token = localStorage.getItem('authToken')

    if (!token) {
        throw new Error('Authorization token not found')
    }

    const response: any = await axios.post(
        `https://${apiURL}/client`,
        props,
        {
            headers: {
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + token,
            },
        }
    )

    return response
}

export const createAccountAddress = async (props: GetClientByIdV2Site): Promise<any> => {
    const token = localStorage.getItem('authToken')

    if (!token) {
        throw new Error('Authorization token not found')
    }

    const response: any = await axios.post(
        `https://${apiURL}/sites`,
        props,
        {
            headers: {
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + token,
            },
        }
    )

    return response
}

export const editAccountAddress = async (props: GetClientByIdV2Site): Promise<any> => {
    const token = localStorage.getItem('authToken')

    if (!token) {
        throw new Error('Authorization token not found')
    }

    const response: any = await axios.put(
        `https://${apiURL}/sites/${props.siteId}`,
        props,
        {
            headers: {
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + token,
            },
        }
    )

    return response
}

export const deleteAccountAddress = async (addressId: number): Promise<any> => {
    const token = localStorage.getItem('authToken')

    if (!token) {
        throw new Error('Authorization token not found')
    }

    const response: any = await axios.delete(
        `https://${apiURL}/sites/${addressId}`,
        {
            headers: {
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + token,
            },
        }
    )

    return response
}


export const createAccountContact = async (props: GetClientByIdV2Contact): Promise<any> => {
    const token = localStorage.getItem('authToken')

    if (!token) {
        throw new Error('Authorization token not found')
    }

    const response: any = await axios.post(
        `https://${apiURL}/Contact`,
        props,
        {
            headers: {
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + token,
            },
        }
    )

    return response
}

export const editAccountContact = async (props: GetClientByIdV2Contact): Promise<any> => {
    const token = localStorage.getItem('authToken')

    if (!token) {
        throw new Error('Authorization token not found')
    }

    const response: any = await axios.put(
        `https://${apiURL}/Contact/${props.contactId}`,
        props,
        {
            headers: {
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + token,
            },
        }
    )

    return response
}

export const deleteAccountContact = async (contactId: number): Promise<any> => {
    const token = localStorage.getItem('authToken')

    if (!token) {
        throw new Error('Authorization token not found')
    }

    const response: any = await axios.delete(
        `https://${apiURL}/Contact/${contactId}`,
        {
            headers: {
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + token,
            },
        }
    )

    return response
}

export const getAccountsForDropdown = async (searchTerm: string): Promise<dropDown[]> => {
    const token = localStorage.getItem('authToken');

    if (!token) {
        throw new Error('Authorization token not found');
    }

    const response = await axios.get(`https://${apiURL}/Account/ForDropdown?filter=${encodeURIComponent(searchTerm)}`, {
        headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + token,
        },
    });

    const data = response.data;

    const dropdown: dropDown[] = (data as dropDown[]).map((item: any) => ({
        text: item.text,
        value: item.value,
    }));

    return dropdown;
};


export const getTitlesForDropdown = async (): Promise<dropDown[]> => {
    const token = localStorage.getItem('authToken');

    if (!token) {
        throw new Error('Authorization token not found');
    }

    const response = await axios.get(`https://${apiURL}/title`, {
        headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + token,
        },
    });

    const data = response.data;

    const dropdown: dropDown[] = (data as dropDown[]).map((item: any) => ({
        text: item.name,
        value: item.titleId,
    }));

    return dropdown;
};

export const getAddressesForAccountDropdown = async (accountId: number): Promise<dropDown[]> => {
    const token = localStorage.getItem('authToken');

    if (!token) {
        throw new Error('Authorization token not found');
    }

    const response = await axios.get(`https://${apiURL}/address/fordropdownforaccount/${accountId}`, {
        headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + token,
        },
    });

    const data = response.data;

    const dropdown: dropDown[] = (data as dropDown[]).map((item: any) => ({
        text: item.name,
        value: item.titleId,
    }));

    return dropdown;
};


export const getAddressesForClientDropdown = async (clientId: number): Promise<dropDown[]> => {
    const token = localStorage.getItem('authToken');

    if (!token) {
        throw new Error('Authorization token not found');
    }

    const response = await axios.get(`https://${apiURL}/sites/ForDropDownForClient/${clientId}`, {
        headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + token,
        },
    });

    const data = response.data;

    const dropdown: dropDown[] = (data as dropDown[]).map((item: any) => ({
        text: item.text,
        value: item.value,
    }));

    return dropdown;
};

export interface GetClientsV2Table {
    clientId: number
    clientName: string
    accountRef?: string
    contactName: string
    clientAddr?: string
    phone?: string
    email: string
    deletedDate: any
    what3Words?: string
  }

export const getClientsV2 = async (showDeleted: boolean): Promise<GetClientsV2Table[]> => {
    const token = localStorage.getItem('authToken');

    if (!token) {
        throw new Error('Authorization token not found');
    }

    const response = await axios.get(`https://${apiURL}/Client?ShowDeleted=${showDeleted}`, {
        headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + token,
        },
    });


    return response.data;
};



export interface GetClientByIdV2 {
    clientId: number
    clientName: string
    accountRef: string
    contactName: string
    contactFirstName: string
    contactLastName: string
    phone: string
    email: string
    clientAddr: string
    postcode: any
    phone2: string
    fax: string
    tradeContact: string
    email2: string
    email3: string
    websiteUrl: string
    vatNum: string
    directdebitEmail: string
    deletedDate: any
    what3Words: string
    notes: string
    openEnquiries: number
    openQuotes: number
    openJobs: number
    badDebter: boolean
    /** Default for the Adjustment (%) on this client's jobs. Zero means none. */
    defaultAdjustment?: number
    xeroBalance?: XeroBalanceResponse | null
    clientLetterUrl?: string | null
    primaryContact: GetClientByIdV2PrimaryContact
    primarySite: GetClientByIdV2PrimarySite
    sites: GetClientByIdV2Site[]
    contacts: GetClientByIdV2Contact[]
  }
  
  export interface GetClientByIdV2PrimaryContact {
    contactId: number
    clientId: number
    titleId: number
    title?: string
    firstname: string
    lastname: string
    fullName: string
    email: string
    phone: string
    isPrimary: any
  }
  
  export interface GetClientByIdV2PrimarySite {
    siteId: number
    siteAddr: string
    postcode: string
    deletedDate: any
    what3Words: string
    latitude: any
    longitude: any
    thoroughfare: any
    buildingName: any
    subBuildingName: any
    subBuildingNumber: any
    buildingNumber: string
    line1: string
    line2: string
    line3: string
    line4: string
    locality: any
    townOrCity: string
    county: string
    district: any
    country: string
    residential: any
    isBilling: any
    isDelivery: any
  }
  
  export interface GetClientByIdV2Site {
    clientId: number
    siteId: number
    siteAddr?: string
    postcode: string
    deletedDate: any
    what3Words: string
    latitude: any
    longitude: any
    thoroughfare: any
    buildingName: any
    subBuildingName: any
    subBuildingNumber: any
    buildingNumber?: string
    line1?: string
    line2?: string
    line3?: string
    line4?: string
    locality: any
    townOrCity?: string
    county?: string
    district: any
    country?: string
    residential: any
    isBilling: any
    isDelivery: any
    isNewFromClient?: boolean
  }
  
  export interface GetClientByIdV2Contact {
    contactId: number
    clientId: number
    titleId: number
    title?: string
    firstname: string
    lastname: string
    fullName: string
    email: string
    phone: string
    isPrimary: any
    isNewFromClient?: boolean
  }
  

export const getClientByIdV2 = async (clientId: number): Promise<GetClientByIdV2> => {
    const token = localStorage.getItem('authToken');

    if (!token) {
        throw new Error('Authorization token not found');
    }

    const response = await axios.get(`https://${apiURL}/Client/${clientId}`, {
        headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + token,
        },
    });

    return response.data;
};



export const getClientsForClientsDropdown = async (clientId: number): Promise<dropDown[]> => {
    const token = localStorage.getItem('authToken');

    if (!token) {
        throw new Error('Authorization token not found');
    }

    const response = await axios.get(`https://${apiURL}/contact/fordropdownforclient/${clientId}`, {
        headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + token,
        },
    });


    return response.data;
};

export interface XeroBalanceResponse {
    success: boolean;
    clientName?: string;
    accountsReceivableOutstanding?: number;
    accountsReceivableOverdue?: number;
    accountsPayableOutstanding?: number;
    accountsPayableOverdue?: number;
    message?: string;
}

export const getClientXeroBalance = async (clientId: number): Promise<XeroBalanceResponse> => {
    const token = localStorage.getItem('authToken');

    if (!token) {
        throw new Error('Authorization token not found');
    }

    try {
        const response = await axios.get(`https://${apiURL}/Client/${clientId}/XeroBalance`, {
            headers: {
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + token,
            },
        });

        return response.data;
    } catch (error: any) {
        // Return error response structure
        if (error.response?.data) {
            return error.response.data;
        }
        return {
            success: false,
            message: 'Failed to fetch Xero balance'
        };
    }
};

export interface ContactDetails {
    contactId: number
    title?: string
    firstname?: string
    lastname?: string
    phone?: string
    email?: string
}

export const getContactById = async (contactId: number): Promise<ContactDetails> => {
    const token = localStorage.getItem('authToken');

    if (!token) {
        throw new Error('Authorization token not found');
    }

    const response = await axios.get(`https://${apiURL}/contact/${contactId}`, {
        headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + token,
        },
    });

    return response.data;
};
